/** Evaluation domain storage. All cross-tab (localStorage): settings object, "another step" overlay dismissals, and the "hide delete skill" flag. */
import Storage from '../index';
import StorageKeys from '../keys';

const evaluation = {
    getSettings: () => Storage.get(StorageKeys.evaluationSettings, {}),
    setSettings: (settings) => Storage.set(StorageKeys.evaluationSettings, settings),

    getAnotherStepOverlay: () => Storage.get(StorageKeys.anotherStepOverlay, []),
    setAnotherStepOverlay: (stepIds) => Storage.set(StorageKeys.anotherStepOverlay, stepIds),

    isDeleteSkillOverlayHidden: () => Storage.getRaw(StorageKeys.hideDeleteSkillOverlay) === 'true',
    hideDeleteSkillOverlay: () => Storage.setRaw(StorageKeys.hideDeleteSkillOverlay, 'true'),
};

export default evaluation;
